<template>
  <div>
    <div class="search-box">
      <input type="text" @click="routePush('/search')">
    </div>
    <div class="doc-list">
      <div class="selects">
        <select @change="Doctorlist()" v-model="disId">
          <option v-for="(item,i) in disList" :value="item.id">{{item.name}}</option>
        </select>
        <select v-model="docpos" @change="Doctorlist()">
          <option>主任医师</option>
          <option>副主任医师</option>
          <option>主治医师</option>
        </select>
        <select v-model="docservice" @change="Doctorlist()">
          <option value="1">图文</option>
          <option value="2">电话</option>
          <option value="3">视频</option>
          <option value="4">挂号</option>
        </select>
      </div>

      <ul class="hot-lists">
        <li v-for="item in docList" @click="routePush('/doctor_content?doctorid='+item.id)">
          <div class="dis-doc-left">
            <div class="item-expert">
              <p class="expert-avar">
                <img :src="item.avatar" class="all-i" alt="">
              </p>
              <i class="icon icon-jiav"></i>
            </div>
          </div>
          <div class="expert-info">
            <div class="item-expert font-85">
              <p class="expert-info-doctor">
                <span class="expert-name">{{item.zname}}</span>
                <span class="expert-pos">{{item.position}}</span>
              </p>
              <p class="expert-info-good">{{item.hospname}}</p>
            </div>
            <div onclick="textClick($(this))" class="item-dis good-hide">
              {{item.goodable}}
            </div>
            <div class="doc-btns">
              <div class="font-65"><i class="icon icon-guahao"></i>预约挂号 ￥XXX起</div>
              <div class="font-65"><i class="icon icon-guahao"></i>在线问诊 ￥{{item.graphic_money}}起</div>
            </div>
          </div>
          <span class="zhankai" onclick="showgood($(this))">展开</span></li>
      </ul>
    </div>
  </div>
</template>

<script>
    import http from "../../request/http";

    export default {
        name: "doctor_list",
        data(){
            return {
              disList:[],
              docList:[],
              disId:0,
              docpos:'',
              docservice:''
            }
        },
        mounted() {
          this.getDisList();
          this.Doctorlist();
        },
        methods:{
          getDisList(){
            http.post('/api/wap/public/distab',{}).then((res)=>{
              console.log(res);
              this.disList = res.data;
            })
          },
          Doctorlist(){
            http.post('/api/wap/doctor/indexlist',{
              pageIndex:1,
              diseasid:this.disId,
              position:this.docpos,
              service:this.docservice
            }).then((res)=>{
              console.log(res)
              this.docList = res.data
            }).catch((error)=>{
              console.log(error)
            })
          },
          routePush(path){
            this.$router.push(path)
          }
        }
    }
</script>

<style scoped>
  @import "../index/index.css";
.search-box{
  width: 100%;
  height: 2.5rem;
}

</style>



// WEBPACK FOOTER //
// src/pages/doctor/doctor_list.vue